/**
 * import中的webpackChunkName，为按需加载生成的JS名称，请使用 [project-name]-[module-name]，示例如下
 */
export default [{
  path: 'createdOrder',
  name:'createdOrder',
  meta: {
      title: '创建的全部工单'
  },
  component: () =>
    import ( /* webpackChunkName: "pop-shopDetail" */ '../views/workOrder/index.vue')
}, {
  path: 'orderIndex',
  name:'orderIndex',
  meta: {
      title: '全部受理工单'
  },
  component: () =>
    import ( /* webpackChunkName: "pop-shopDetail" */ '../views/handleOrder/index.vue')
}]

// , {
//   path: 'handleOrder',
//   name:'handleOrder',
//   meta: {
//       title: '待处理工单'
//   },
//   component: () =>
//     import ( /* webpackChunkName: "pop-shopDetail" */ '../views/workOrder/handleOrder.vue')
// }, {
//   path: 'overOrder',
//   name:'overOrder',
//   meta: {
//       title: '我已处理工单'
//   },
//   component: () =>
//     import ( /* webpackChunkName: "pop-shopDetail" */ '../views/workOrder/overOrder.vue')
// }